export const notifyLayoutValuesChanged = (subjectId) => {
  window.dispatchEvent(
    new CustomEvent('layout-values-changed', { detail: { subjectId } })
  );
};
